import { render, staticRenderFns } from "./public-restricted-messaging-times.vue?vue&type=template&id=c74a2b3c&scoped=true&"
import script from "./public-restricted-messaging-times.vue?vue&type=script&lang=js&"
export * from "./public-restricted-messaging-times.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74a2b3c",
  null
  
)

export default component.exports